export default __webpack_public_path__ + "static/media/logo_ouigo_vitesse_classique.5a5546ca.svg";